import { useQuery } from "@tanstack/react-query";
import { scoreScenario } from "./api";

// useScenarioScore POSTs the levers and returns the baseline-vs-scenario score.
// Keyed on (period, adjustments) so it re-scores when levers change; the caller
// debounces the adjustments it passes in.
export function useScenarioScore(period, adjustments) {
  return useQuery({
    queryKey: ["scenario-score", period, JSON.stringify(adjustments || [])],
    queryFn: () => scoreScenario({ period, adjustments: adjustments || [] }),
    enabled: !!period,
    keepPreviousData: true,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
}
